import { createAction } from '@reduxjs/toolkit';

export const updateFieldInteraction = createAction<string>('userInteraction/UPDATE_FIELD_INTERACTION');
